<template>
  <div style="margin:5px;" class="rowTitle">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab" @click="invsummary = !!invsummary">
        {{$parent.lang.work_price}} </b-card-header>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <v-form ref="formmem">
            <v-simple-table striped hover style="width:100%;">
              <template v-slot:default>
                <thead> 
                <tr>
                  <th style="direction:rtl;padding:1px;text-align:center;">{{$parent.lang.description}}</th>
                  <!-- <th style="direction:rtl;padding:1px;text-align:center;width:90px">التكلفة</th> -->
                  <th style="direction:rtl;padding:1px;text-align:center;width:90px">{{$parent.lang.item_price}}</th>
                  <th style="direction:rtl;padding:1px;text-align:center;width:86px;" v-if="canceled === false"></th>
                </tr>
                </thead>
                <tbody>
                <tr 
                    v-for="(item,index) in items"
                    :key="item.id"
                >
                  <td style="white-space:normal !important;">{{ item.description }}</td>
                  <!-- <td>{{ item.cost }}</td> -->
                  <td>{{ item.price }}</td>
                  <td v-if="canceled === false">
                    <v-btn class="ma-1" :id="`wdel_`+item.id" style="height:25px;background:red;color:#FFF;width:70px" @click="DeleteLabor( index )">{{$parent.lang.delete}}</v-btn>
                    <!-- <v-btn class="ma-1" :id="`wdone_`+item.id" style="height:25px;background:green;color:#FFF;width:70px" @click="finishJob( index )">انتهت</v-btn> -->
                  </td>
                </tr>
                <tr v-if="canceled === false">
                  <td style="white-space:normal !important;">
                    <v-combobox
                        v-model="description"
                        :items="carworkdes"
                        :rules="fieldRules"
                      ></v-combobox>
                    <!-- <b-input v-model="description" id="description_" style="font-size: 0.8rem"></b-input> -->
                  </td>
                  <td style="display:none">
                    <b-input v-model="cost" id="cost_" style="font-size: 0.8rem"></b-input>
                  </td>
                  <td>
                    <b-input v-model="price" id="price_" :rules="numberRules" style="font-size: 0.8rem"></b-input>
                  </td>
                  <td>
                    <v-btn class="ma-1" style="height:25px;background:green;color:#FFF;width:70px" @click="EditLabor( 0 )">{{$parent.lang.add}}</v-btn>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
            </v-form>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'CVSubletsTable',
  props: ['canceled'],
  components: {},
  data: () => ({
    items:[
      
    ],
    description: '',
    cost: '',
    price: '',
    cardid: '',
    carworkdes:[],
    fieldRules:[
      v => !!v || 'الحقل مطلوب',
    ],
    numberRules:[
      val => {if(val <= 0) return `ادخل رقم غير صفر`}
    ],
  }),
  created(){
    this.cardid = this.$route.params.cardid;
    this.getService();
    this.getWorkerds();
  },
  methods: {
    finishJob(id){
      this.$parent.NewDone.push(this.items[id]);
      document.getElementById('wdone_'+this.items[id].id).style.display = "none";
      document.getElementById('wdel_'+this.items[id].id).style.display = "none";
    },
    EditLabor(id){
      // const x = 1;
      // if(x == 1){
      //   // this.$parent.NewWork.push(this.items[id]);
      //   if (this.$snotify.notifications.length > 0) {
      //         this.$snotify.notifications.forEach(notification => {
      //             this.$snotify.remove(notification.id)
      //         });
      //     }
      //   if(!this.$refs.formmem.validate()){
      //     return false;
      //   }
      //   if(this.price == 0){
      //     this.$snotify.error('يجب ادخال رقم اكبر من الصفر', '', {
      //       timeout: 2000,
      //       showProgressBar: false,
      //       closeOnClick: false,
      //       pauseOnHover: true
      //     })
      //     return false;
      //   }
      //   this.items.push({
      //     cardid: this.cardid,
      //     description: this.description,
      //     cost: this.cost,
      //     price: this.price,
      //     type: "service",
      //     total: 0,
      //     qty: 1,
      //   });
      //   this.$parent.NewWork.push({
      //     cardid: this.cardid,
      //     description: this.description,
      //     cost: this.cost,
      //     price: this.price,
      //     type: "service",
      //     total: 0,
      //     qty: 1,
      //   });
      //   this.cardid = "";
      //   this.description = "";
      //   this.cost = "";
      //   this.price = "";
      //   this.type = "service";
      //   this.total = 0;
      //   this.qty = 1;
      //   return false;
      // }
      if (this.$snotify.notifications.length > 0) {
              this.$snotify.notifications.forEach(notification => {
                  this.$snotify.remove(notification.id)
              });
          }
      if(!this.$refs.formmem.validate()){
        return false;
      }
      if(this.price == 0){
        this.$snotify.error('يجب ادخال رقم اكبر من الصفر', '', {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        })
        return false;
      }
      const formdata = new FormData();
      formdata.append('type','updateCItem');
      formdata.append('auth',this.$cookies.get(this.$COOKIEPhase));
      formdata.append('data[cardid]',this.cardid);
      formdata.append('data[type]','service');

      if(id == 0){
        formdata.append('data[description]',this.description);
        formdata.append('data[cost]',this.cost);
        formdata.append('data[price]',this.price);
        formdata.append('data[total]',0);
        formdata.append('data[qty]',1);
        axios.post(
          this.$SAMCOTEC.r_path, formdata
        ).then((response) => {
          const res = response.data;
          this.cost = 0;
          this.price = 0;
          this.description = '';
          this.getService();
        }).then(()=>{
          this.$parent.getCard()
        });
      }
    },
    DeleteLabor(id){
      // const x = 1;
      // if(x == 1){
      //   if(this.items[id].id !== 'undefined'){
      //     this.$parent.NewDel.push(this.items[id]);
      //     this.items.splice(id);
      //     return false;
      //   }else{
      //     this.$parent.NewDel.splice(this.items[id]);
      //     this.items.splice(id);
      //   }
      //   return false;
        
      // }
      const ritem = this.items[id];
      this.items.splice(id);
      const post = new FormData();
      post.append('type','deletedItem');
      post.append('auth',this.$cookies.get(this.$COOKIEPhase));
      post.append('data[id]',ritem.id);
      axios.post(
        this.$SAMCOTEC.r_path, post
      ).then(
        (response) => {
          const res = response.data;
          if(res.error.number == 200){
            this.carworkdes = res.results.data;
          }
        }
      )

    },
    getWorkerds(){
      this.carworkdes = [];
      const post = new FormData();
      post.append('type','getWorkerds');
      post.append('auth',this.$cookies.get(this.$COOKIEPhase));
      post.append('data[mobile]','1');
      axios.post(
        this.$SAMCOTEC.r_path, post
      ).then(
        (response) => {
          const res = response.data;
          if(res.error.number == 200){
            this.carworkdes = res.results.data;
          }
        }
      )
    },
    getService(){
      const formdata = new FormData();
      formdata.append('type','getCItem');
      formdata.append('auth',this.$cookies.get(this.$COOKIEPhase));
      formdata.append('data[cardid]',this.cardid);
      formdata.append('data[type]','service');
       axios.post(
          this.$SAMCOTEC.r_path, formdata
        ).then((response) => {
          const res = response.data;
          this.items = res.results.data.results;
        });
    }
  }
}
</script>
<style>
.rowTitle{
  background:#FFF;
  color:#000;
  font-size:14px;
  text-align: right;
  padding:3px 3px 5px 3px;
}
</style>